import React, { useMemo, useState, VFC } from 'react';

import ReCAPTCHA from 'react-google-recaptcha';
import { Button, Modal } from '../common';
import { LOGIN } from '../../constants';
import LoginFail from './LoginFail';
import { LoginProps } from './types';
import useLogIn from '../../hooks/mutates/useLogIn';
import { setDisposableTokenTokenInLocalStorage } from '../../storage/token';
import OTPProvider from '../../providers/OTPProvider';
import { OTPModalType } from '../../hooks/mutates/useOTP';
import useRecaptcha from '../../hooks/common/useRecaptcha';
import LoginSuccess from './LoginSuccess';
import { JWTTokens } from '../../apis/kstadiumAPI/logIn/types';

const Login: VFC<LoginProps> = ({ onRequestClose, onSuccess, onFail }) => {
  const [OTPModal, setOTPModal] = useState<OTPModalType | null>(null);
  const [jwtTokens, setJwtTokens] = useState<JWTTokens | null>(null);
  const { register, onSubmit, isValid, fail } = useLogIn({
    onSuccess: ({ data: tokens }) => {
      setDisposableTokenTokenInLocalStorage(tokens.accessToken);
      // Note: Modal을 지역적으로 사용하고 있어 해당 로직 추가할 수 밖에 없음
      // 전역적으로 관리할 수 있도록 수정 필요
      setOTPModal(`otp`);
    },
  });
  const { isValid: isRecaptchaValid, handleChange } = useRecaptcha();

  const handleCloseModal = () => {
    setOTPModal(null);
    onRequestClose();
  };

  const handleSuccessOTP = (tokens) => {
    setJwtTokens(tokens);
  };
  const handleSuccessLogIn = () => {
    if (jwtTokens) onSuccess(jwtTokens);
  };

  const logInForm = useMemo(() => {
    return (
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <input
            {...register(`userId`, {
              required: true,
            })}
            type="text"
            className="form-input input-lg"
            placeholder="ID"
          />
          <br />
          <input
            {...register(`password`, { required: true })}
            type="password"
            className="form-input input-lg"
            placeholder="Password"
          />
          <br />
          <div style={{ transform: `scale(1.32)`, transformOrigin: `0 0` }}>
            <ReCAPTCHA
              size="normal"
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY || ``}
              onChange={handleChange}
            />
          </div>
        </div>
      </form>
    );
  }, [register, onSubmit, handleChange]);

  if (fail) {
    return <LoginFail onRequestClose={onRequestClose} onConfirm={onFail} />;
  }

  return (
    <OTPProvider
      type="logIn"
      OTPModal={OTPModal}
      setOTPModal={setOTPModal}
      onSuccess={handleSuccessOTP}
      handleCloseModal={handleCloseModal}
    >
      {jwtTokens ? (
        <LoginSuccess
          onRequestClose={handleSuccessLogIn}
          onConfirm={handleSuccessLogIn}
        />
      ) : (
        <Modal
          size="fit"
          isShow={!OTPModal}
          title={LOGIN.LOGIN_TITLE}
          onClose={onRequestClose}
          explanation={LOGIN.LOGIN_CONTENT}
          headerComponentExtended={logInForm}
          footerComponent={
            <Button
              onClick={onSubmit}
              title="Sign in"
              disabled={!isValid || !isRecaptchaValid}
            />
          }
        />
      )}
    </OTPProvider>
  );
};

export default Login;
